import { format } from 'date-fns';

export const formatBatchTimestamp = (iso: string | Date): string =>
	format(new Date(iso), 'HH:mm dd/MM/yy');
